<template>
	<div class="b-modal_stock">
		<div class="b-order__subtitle b-title_center">
			<h4 class="b-modal__title" v-html="modalText()"></h4>
			<template v-for="product in params.productList">
				<div v-if="product.stock.count < product.quantity && product.stock.enable"
					 class="b-productCard b-productCard_order b-productCard_line b-productCard_modal" itemscope
					 itemtype="http://schema.org/Product"
					 :id="product.areaId">
					<a :href="product.detailPageUrl" class="b-productCard__top">
						<div class="b-productCard__front">
							<picture class="b-productCard__imgWrap" :class="{'b-productCard__imgWrap_none': product.stock.count == 0}">
								<img class="b-productCard__img" :src="product.picture_src" :alt="product.name"/>
							</picture>
						</div>
					</a>
					<div class="b-productCard__bottom">
						<div class="b-productCard__title" itemprop="name" v-html="product.name"></div>
						<div class="b-productCard__content">
							<div class="b-price b-price_productCard b-productCard__price"><!---->
								<div class="b-price__item b-price__item_current"><span
									v-html="product.stock.count"></span> <span>шт.</span></div>
							</div>
						</div>
					</div>
				</div>
			</template>
		</div>

		<div class="b-modal__footer b-modal__footer_col">
			<button
				type="button"
				class="b-btn b-btn_primary b-modal__btn"
				v-html="loc.SOA_ORDER_MODAL_DELIVERY_CHANGE_DATE"
				@click="onChange"
				:class="{'loader': params.loading}"
			></button>
			<button
				type="button"
				class="b-btn b-btn_transparent b-modal__btn"
				v-html="loc.SOA_ORDER_MODAL_DELIVERY_CANCEL"
				@click="onCancel"
			></button>
		</div>
<!--		<p v-html="modalTextDescription()" class="mt-25px"></p>-->
	</div>
</template>

<script>
import {Vue} from "ui.vue";
import CitrusProductPopupItem from "./product/CitrusProductPopupItem.vue"


export default {
	name: "PopupChangeDeliveryTime",
	components: {
		CitrusProductPopupItem
	},
	props: {
		params: {
			type: [Array, Object],
			default: () => {
				return {
					productList: [],
					warningDateTime: "",
					warningDateTypeTime: null
				}
			}
		},
	},
	computed: {
		loc() {
			return Object.freeze(Vue.getFilteredPhrases("SOA_ORDER_MODAL_DELIVERY_"));
		}
	},
	methods: {
		onChange() {
			// изменить состав корзины
			// установить выбранное дату время this.warningDateTime
			let products = [];
			this.params.productList.forEach((product)=>{
				if (product.stock.count < product.quantity && product.stock.enable) {
					products.push({id: product.product_id, quantity: product.stock.count});
				}
			});
			this.$emit("changebasketanddeliverydate", {products: products, deliveryDateTime: this.params.warningDateTime});
		},
		onCancel() {
			this.$emit("changedeliverydate", {deliveryDateTypeTime: this.params.cancelDateTypeTime, deliveryDateTime: this.params.cancelDateTime});

			this.close();
		},
		close() {
			this.$emit("next");
		},
		modalText() {
			return BX.message.CITRUS_QUANTITY_TRACE_POPUP_DELIVERY_TITLE
				? BX.message.CITRUS_QUANTITY_TRACE_POPUP_DELIVERY_TITLE
				: "";
		},
		modalTextDescription() {
			return BX.message.CITRUS_QUANTITY_TRACE_POPUP_NOT_STOCK_DESCRIPTION
				? BX.message.CITRUS_QUANTITY_TRACE_POPUP_NOT_STOCK_DESCRIPTION
				: "";
		},
	}
}
</script>